import React, { Fragment } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';
import { t } from 'src/utils/translate';

import Button from 'components/Button';

const Info = ({ plan }) => {
  return (
    <Root>
      <Details>
        <h2>
          {t('plans.plan')} {plan.id}
        </h2>
        <h4>
          {plan.studio && t('plans.studio')}
          {plan.bed && (
            <Fragment>
              {plan.bed} {t('plans.bed')}
            </Fragment>
          )}
          {plan.bath && (
            <Fragment>
              {' '}
              + {plan.bath} {t('plans.bath')}
            </Fragment>
          )}
          {plan.den && <Fragment> + {t('plans.den')}</Fragment>}
          <br />
          {t('plans.interior')}: {plan.interior} {t('plans.sqft')}
          <br />
          {plan.exterior &&
            <span>{t('plans.exterior')}: {plan.exterior} {t('plans.sqft')}</span>}
          <br />
        </h4>
        <Button
          href={`/assets/floorplans/${plan.pdf || plan.id.toLowerCase()}.pdf`}
          target="_blank"
        >
          {t('plans.download')}
        </Button>
      </Details>
      
    </Root>
  );
};

const Root = styled.div`
  /* position: relative; */
  position: absolute;
  left: 20px;
  top: 20px;
  width: 100%;
`;

const Details = styled.div`
  position: absolute;
  top: 60px;
  left: 20px;
  h2 {
    margin-bottom: 20px;
    font-size: 48px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colorPrimary};
  }
  h4 {
    margin-bottom: 25px;
    color: #4a4a4a;
    font-family: ${({ theme }) => theme.fontBold};
    font-size: 24px;
    text-transform: uppercase;
  }
  @media (max-width: ${media.md}) {
    top: 20px;
    left: 0px;
    h2 {
      margin-bottom: 15px;
      font-size: 30px;
    }
    h4 {
      margin-bottom: 15px;
      font-size: 18px;
    }
  }
`;



export default Info;



// WEBPACK FOOTER //
// ./src/pages/Plans/elements/Info.js